import styled from '@emotion/styled'

import { WithTheme } from './../../../setup/index'
import { transition } from './../../../common/Mixins'
import media from './../../../common/MediaQueries'
import arrow from './../../../assets/images/careers-arrow.png'

const CareersContainerStyled = styled.div<WithTheme>`
  width: 100%;

  .BambooHR-ATS-board h2 {
    display: none;
  }

  .BambooHR-ATS-Department-Item {
    &:not(:last-of-type) {
      margin-bottom: 2.5rem !important;
    }
    @media ${media.phone} {
      &:not(:last-of-type) {
        margin-bottom: 3.5rem !important;
      }
    }
  }

  .BambooHR-ATS-Department-Header {
    font-size: 1.25rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.black};
    opacity: 0.5;
    margin-bottom: 2.125rem;

    @media ${media.phone} {
      padding-left: 2.875rem;
    }
  }

  .BambooHR-ATS-Jobs-List {
    border: none !important;
    padding: 0 !important;
  }

  .BambooHR-ATS-Jobs-Item {
    ${transition}
    display: flex;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0rem 0.625rem 0.625rem 0rem rgba(0, 0, 0, 0.02);

    &:not(:last-of-type) {
      margin-bottom: 1.5rem !important;
    }
    &:hover {
      box-shadow: none;
    }
  }

  .BambooHR-ATS-Jobs-Item a {
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    font-size: 1.0625rem;
    color: ${({ theme }) => theme.colors.black};
    width: 100%;
    padding: 1.125rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:after {
      ${transition}
      content: '';
      background-image: url(${arrow});
      background-repeat: no-repeat;
      background-size: cover;
      margin-left: auto;
      width: 0.75rem;
      min-width: 0.75rem;
      height: 1.3125rem;
      margin-left: 0.625rem;
    }

    @media ${media.phone} {
      padding: 1.25rem 2.875rem;
    }

    &:hover {
      &:after {
        transform: translateX(0.625rem);
      }
    }
  }
  .BambooHR-ATS-Location {
    display: none;
  }
`

export { CareersContainerStyled }
